export default __webpack_public_path__ + "b80f2a46335739b915d3f94c71be30df.svg";